import { Dispatch, SetStateAction, useCallback } from 'react'
import { filterBreadsByCategory, filterBreadsByKeyword, filterBreadsByPage } from 'lib/filter'
import { BreadType } from 'types/bread'
import { CategoryType } from 'types/category'
import { StockType } from 'types/stock'

const useSearchStocks = (
  breads: BreadType[],
  categories: CategoryType[],
  categoryName: string,
  keyword: string,
  setBreadList: Dispatch<SetStateAction<BreadType[]>>,
  page: 'released' | 'unreleased',
  stocks: StockType[]
) => {
  return useCallback(
    (keyword: string) => {
      // カテゴリでフィルターした後にキーワードでフィルタリング
      const filteredBreadsByPage = filterBreadsByPage(page, breads, stocks)
      const filteredBreadsByCategory = filterBreadsByCategory(categoryName, categories, filteredBreadsByPage)
      const filteredBreadsByKeyword = filterBreadsByKeyword(keyword, filteredBreadsByCategory)
      setBreadList([...filteredBreadsByKeyword])
    },
    [breads, categories, keyword, categoryName, setBreadList, page, stocks]
  )
}

export default useSearchStocks
